/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NoteEmailAddress
 */
export interface NoteEmailAddress {
  /**
   *
   * @type {string}
   * @memberof NoteEmailAddress
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof NoteEmailAddress
   */
  emailAddress?: string;
}

/**
 * Check if a given object implements the NoteEmailAddress interface.
 */
export function instanceOfNoteEmailAddress(
  value: object,
): value is NoteEmailAddress {
  return true;
}

export function NoteEmailAddressFromJSON(json: any): NoteEmailAddress {
  return NoteEmailAddressFromJSONTyped(json, false);
}

export function NoteEmailAddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NoteEmailAddress {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    emailAddress:
      json["emailAddress"] == null ? undefined : json["emailAddress"],
  };
}

export function NoteEmailAddressToJSON(json: any): NoteEmailAddress {
  return NoteEmailAddressToJSONTyped(json, false);
}

export function NoteEmailAddressToJSONTyped(
  value?: NoteEmailAddress | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    emailAddress: value["emailAddress"],
  };
}
